{{#if preview}}
  Show an organizational unit selector
{{else}}
  {{#> elements/_dt}}
    {{> elements/_label }}
  {{/elements/_dt}}
  <dd>
    {{sp_select_tag (sp_select_name prefix "[organizational_unit]")
      choices=select_items
      includeBlank=false
      searchable=select_searchable
      selected=value
      id=id
      required=required
      disabled=disabled
    }}
  </dd>
{{/if}}
